<template>
    <div class="main-page boost-page">
        <div class="hero-shell">
            <div class="navigation boost-nav">
                <span>
                    <img src="../assets/arrow-back.png" alt="" width="30px" style="cursor:pointer" @click="back">
                </span>
                <span class="elipse">
                    <!-- <img src="../../assets/elipse.png" alt=""> -->
                </span>
            </div>
            <div class="hero-copy">
                <p class="eyebrow mb-2">Boost center</p>
                <h2 class="hero-title">Boost Plans</h2>
                <p class="hero-desc">Select a plan category to boost your ad, profile visibility, or premium placement.</p>
            </div>
        </div>
        <div>
            <transition name="modal">
                <div class="modal-masky plans-mask">
                    <div class="modal-wrapper col-lg-8 col-sm-10 col-md-9" style="margin:auto">
                        <div class="plans-panel">

                            <!-- Title -->
                            <div class="row text-center plans-title">
                                <div class="plans-kicker">Choose a category</div>
                                <h3 class="player-title mt-2">Boost Plans</h3>
                                <div class="player-payinfo">
                                    Select a plan category to boost your ad or visibility.
                                </div>
                            </div>

                        <!-- BOOSTING -->
                        <div v-if="boostingPlans.length" class="plans-group">
                            <h4 class="section-heading">Profile Listing Plans</h4>
                            <div class="row g-3">
                                <div 
                                    class="col-6 col-md-4 mb-1"
                                    v-for="(plan, index) in boostingPlans"
                                    :key="'boost-' + index"
                                >
                                    <div class="plan-card plan-card--interactive"
                                        @click="selectBoostPlan(plan)"
                                        style="cursor:pointer">
                                        <div class="plan-badge">Boost</div>
                                        <h4>{{ plan.name }}</h4>
                                        <p class="plan-price"><strong>{{ formatPrice(plan.dayruns_token) }}{{ token_label }}</strong></p>
                                        <p class="plan-desc text-muted small">{{ plan.description }}</p>
                                        <div class="plan-foot">Tap to select</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- BANNER -->
                        <div v-if="bannerPlans.length" class="plans-group">
                            <h4 class="section-heading">Banner Plans</h4>
                            <div class="row g-3">
                                <div 
                                    class="col-6 col-md-4 mb-1"
                                    v-for="(plan, index) in bannerPlans"
                                    :key="'banner-' + index"
                                >
                                    <div class="plan-card plan-card--interactive"
                                        @click="selectBoostPlan(plan)"
                                        style="cursor:pointer">
                                        <div class="plan-badge plan-badge--accent">Featured</div>
                                        <h4>{{ plan.name }}</h4>
                                        <p class="plan-price"><strong>{{ formatPrice(plan.dayruns_token) }}{{ token_label }}</strong></p>
                                        <p class="plan-desc text-muted small">{{ plan.description }}</p>
                                        <div class="plan-foot">Tap to select</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- ACTIVATION -->
                        <div v-if="activationPlans.length" class="plans-group">
                            <h4 class="section-heading">VIP Plans</h4>
                            <div class="row g-3">
                                <div 
                                    class="col-md-12"
                                    v-for="(plan, index) in activationPlans"
                                    :key="'activation-' + index"
                                >
                                    <div class="plan-card plan-card--vip plan-card--interactive"
                                        @click="selectBoostPlan(plan)"
                                        style="cursor:pointer">
                                        <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2">
                                            <div>
                                                <div class="plan-badge plan-badge--vip">VIP</div>
                                                <h4 class="mb-1">VIP Plan</h4>
                                                <p class="plan-desc text-muted small mb-0" style="font-weight: 500;">{{ plan.description }}</p>
                                            </div>
                                            <div class="text-md-end">
                                                <p class="plan-price mb-0"><strong>{{ formatPrice(plan.dayruns_token) }}{{ token_label }}</strong></p>
                                            </div>
                                        </div>
                                        <div class="plan-foot mt-3">Tap to select</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Skip Button -->
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <button class="player-button" @click="skip()">Skip</button>
                            </div>
                        </div>

                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="choose_credittype">
            <transition name="modal-fade" >
                <div class="modal-maskp payment-mask">
                    <div class="modal-wrapper col-md-5 payment-wrapper" style="margin:auto">
                        <div class="payment-panel">
                        <div class="row">
                            <div class="col-md-2">
                            </div>
                            <div class="col-md-8">
                                <br>
                                <center> <h3 class="player-title">Boost Profile</h3></center> 
                            </div>
                            <div class="col-md-2">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-2">
                            </div>
                            <div class="col-md-8">
                                <div class="player-payinfo">
                                    <p>
                                        Choose your preffered payment option below
                                    </p>
                                </div>
                                <div class="amount">
                                    <span class="fees">Subscription Fee  ( <strong>{{ package_name }} Package</strong> ):</span>
                                    <span class="price">{{ formatPrice(this.fees) }}</span>
                                </div>
                            <div class="payment-option">
                                <div class="payment-types">
                                    <p class="payhow">How do you want to pay?</p>
                                    <div class="payment payment-card" @click="makePayment">
                                        <img src="../assets/card.png" alt="" width="20px">&nbsp;&nbsp;  Credit / Debit Card
                                    </div>
                                    <div class="payment payment-card" @click="makePayment">
                                        <img src="../assets/bank.png" alt="" width="20px">&nbsp;&nbsp;  Bank Transfer
                                    </div>
                                    <div class="payment payment-card">
                                        <a href="https://wa.me/2347080576219" target="_blank" style="text-decoration: none; color: #f9f9f9; display: flex; flex-direction: row; justify-content: left; align-items: center;">
                                            <img src="../assets/bank.png" alt="" width="20px">&nbsp;&nbsp; USSD
                                        </a>
                                    </div>

                                    <button class="player-button" @click="skip_payment()">Skip</button>
                                </div>
                            </div>
                            
                            </div>
                            <div class="col-md-2">
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div> 

        <div class="loader" v-if="pageLoader">
            <span class="dot"></span> 
            <span class="dot"></span>
            <span class="dot"></span>
        </div>
    </div>
</template>
<script>
//import Vue from 'vue'
import swal from 'sweetalert2';

export default {
    components: {
     
    },

data() {
  return {

    pageLoader: false,
    image_path: '',
    find_match: true,
    your_match: false,
    filtering: false,
    filtering2: false,
    nextOption: false,
    viewMatchProfile: false,
    select_player: false,
    choose_game: false,
    choose_mode: false,
    choose_credittype: false,
    player: false,
    response: '',
    location: '',
    religion: '',
    male: '',
    female: '',
    value: [0, 100],
    user_profile: [],
    profile_pictures: [],
    view_profile: [],
    user_ages: [],
    view_age: '',
    show_profile: [],
    show_age: '',
    options: [],
    match_status: '',
    match_profile: [],
    match_pictures: [],
    match_ages: [],
    show_picture: '',
    user_message: '',
    user_id: '',
    message_status: false,
    profile: false,
    myprofile: '',
    userphoto: '',
    client_profile:'',
    paid: '',
    game_type_status: '',
    payment_ref: '',
    user_country: '',
    country_dial_code:'',
    country_iso2: '',
    user_email: '',
    apikey:'',
    fees: 0,
    regular: 0,
    silver: 0,
    gold: 0,
    package: 0,
    package_name: '',
    boost_plans: [],
    selected_plan: null,
    userid: '',

    boostingPlans: [],
    bannerPlans: [],
    activationPlans: [],
    selected_activation_type: '',
    token_label: process.env.VUE_APP_TOKEN_LABEL

  };
},

async beforeMount(){
   this.userid = this.$route.params.escortid;
   await this.listBoostPlans();
   await this.listEscortProfile(this.userid)
   await this.getConfigData()
},

mounted(){
    //this.$router.replace({ path: '/plans' }); 
},

methods: {

    async getConfigData(){
        const response = await fetch('/config.json');
        const configData = await response.json();
        this.apikey = configData.apikey;
    },

    formatPrice(price) {
    return new Intl.NumberFormat('en-NG', {
        //   style: 'currency',
        //   currency: 'NGN',
        minimumFractionDigits: 0
        }).format(price);
    },

    async selectBoostPlan(plan) {
        try {
                // Confirmation prompt
                const confirmed = confirm("Are you sure you want to subscribe?");
                if (!confirmed) return; // Stop if user cancels

                const payload = {
                    escort_id: this.userid,
                    boost_plan_id: plan.id,
                };

                const response = await this.$http.post('/api/check-escort-subscription', payload);

                if (response.data.success) {
                    this.selected_plan = plan;
                    this.package_name = plan.name;
                    this.selected_activation_type = plan.activation_type
                    const reference = Date.now()
                    const payment_desc =  `${reference} - Boosting plan for ${this.package_name}`
                    this.createEscortBoost(this.userid, this.selected_plan.id, payment_desc, this.selected_activation_type, plan.dayruns_token)
                } 
            } catch (error) {
            console.error("Boost activation failed:", error);
            alert(error.response?.data?.message || 'Server error occurred.',);
           }
    },

    skip(){
        this.$router.back();
    },
    skip_payment(){
        this.choose_credittype = false
    },
    onSelect({name, iso2, dialCode}) {
       this.country_iso2 = iso2
       this.user_country = name
       this.country_dial_code = dialCode
     },

    async createEscortBoost(userid, plan_id, payment_reference, activation_type, dayruns_token) {
        try {
        
        const payload = {
            escort_id: userid,
            boost_plan_id: plan_id,
            payment_reference: payment_reference,
            subscription_type: activation_type,
            dayruns_token: dayruns_token,
        };

        const response = await this.$http.post('/api/create-escort-boost', payload);

        if (response.data.success) {
            alert(`Boost plan "${this.package_name}" activated!`);
            this.skip()
        } else {
            alert(response.data.message);
        }
        } catch (error) {
        console.error("Boost activation failed:", error);
        alert(error.response?.data?.message || 'Server error occurred.',);
        }
    },

    async listEscortProfile(userid){
         try{

            const response = await this.$http.post('/list-escort-byid-boosts',{ user_id: userid} )
            this.escort_info = response.data.data;
            this.escortid = this.escort_info.id
            this.user_email = this.escort_info.email_address
           
            await localStorage.setItem('email', this.escort_data.email_address);

            }catch (err) {
                console.log(err);
            }
    },

    back() {
        this.searchProfile()
        this.profile = false
        this.find_match = true
        
    },

    close() {
        this.choose_game = false
        //this.$router.push('/home');
    },

    async pay(e, y) {
        try{
            this.response = await this.$http.post('/pay-with-paystack', {
                payment_ref: e,
                amount: this.fees,
                package: y
            });

        if (!this.response.data.success) {
                swal.fire({
                    title: 'error',
                    width:450,
                    height:5,
                    text: this.response.data.message,
                });
                return;

            } else {

                swal.fire({
                    icon: 'success',
                    title: 'Success',
                    width:450,
                    height:5,
                    text: this.response.data.message,
                });
                this.choose_credittype = false

                return;              

        }
                            
        }catch (err) {
            console.log(err);
        }

    },

    async match(e) {
        try{
            
        this.filtering2 = true
        this.response = await this.$http.post('/match-profile-hangout', {
            userid: e,
        });

        this.filtering2 = false

        if (!this.response.data.success) {
            swal.fire({
                title: 'error',
                width:350,
                height:3,
                text: this.response.data.message,
                });
                return;

            } else {

                this.match_status = this.response.data.match_status; 
                swal.fire({
                title: 'success',
                width:350,
                height:3,
                text: this.response.data.message,
                });
                return;              

        }
                            
        }catch (err) {
            console.log(err);
        }

    },

    async unmatch(e) {
        // eslint-disable-next-line
        try{
            
        this.filtering2 = true
        this.response = await this.$http.post('/unmatch-profile-hangout', {
            userid: e,
        });

        this.filtering2 = false

        if (!this.response.data.success) {
            swal.fire({
                title: 'success',
                width:350,
                height:3,
                text: this.response.data.message,
                });
                return;

            } else {

                this.match_status = this.response.data.match_status;                

        }
                            
        }catch (err) {
            console.log(err);
        }

    },

    findMatch() {
        this.find_match = true
        this.your_match = false

        var t = document.getElementsByClassName("your-matches");
        t[0].style.backgroundColor = "transparent";
        t[0].style.borderBottom = "1px solid #000";

        var ts = document.getElementsByClassName("pyour-match");
        ts[0].style.color = "#767475";

        var r = document.getElementsByClassName("find-match");
        r[0].style.backgroundColor = "#1E1D20";
        r[0].style.marginTop="-10px";
        r[0].style.borderBottom = "1px solid #D33E74";
        r[0].style.padding = "15px";
        r[0].style.height ="70px";
        
        var rs = document.getElementsByClassName("pfind-match");
        rs[0].style.color = "#D33E74";
        rs[0].style.textAlign = "center";
    },

    yourMatch() {
        this.find_match = false
        this.your_match = true
        this.loadMatchProfile()
        var t = document.getElementsByClassName("find-match");
        t[0].style.backgroundColor = "transparent";
        t[0].style.borderBottom = "1px solid #000";

        var ts = document.getElementsByClassName("pfind-match");
        ts[0].style.color = "#767475";

        var r = document.getElementsByClassName("your-matches");
        r[0].style.backgroundColor = "#1E1D20";
        r[0].style.marginTop="-10px";
        r[0].style.borderBottom = "1px solid #D33E74";
        r[0].style.padding = "15px";
        r[0].style.height ="70px";
        
        var rs = document.getElementsByClassName("pyour-match");
        rs[0].style.color = "#D33E74";
        rs[0].style.textAlign = "center";
    },

    hide(x) {
        var t = document.getElementsByClassName("photo-footer1"+x);
        t[0].style.display = "block";

        var s = document.getElementsByClassName("photo-footer"+x);
        s[0].style.display = "none";
       
    },

    unhide(x) {
        var t = document.getElementsByClassName("photo-footer"+x);
        t[0].style.display = "block";

        var s = document.getElementsByClassName("photo-footer1"+x);
        s[0].style.display = "none";
       
    },

    async getStates() {
        try{
            const response = await this.$http.get('/all-states', )
            this.options = response.data.states;
                    
        }catch (err) {
            console.log(err);
        }
    },
    
    async listBoostPlans() {
    try {
        const response = await this.$http.get('/list-boost-plans');
        this.boost_plans = response.data.data;

        // Categorize
        this.boostingPlans = this.boost_plans.filter(p => p.activation_type === "boosting");
        this.bannerPlans = this.boost_plans.filter(p => p.activation_type === "banner");
        this.activationPlans = this.boost_plans.filter(p => p.activation_type === "activation" && p.model_role === "vip");

    } catch (err) {
        console.log(err);
    }
},

    async searchProfile(){
         try{
            this.pageLoader = true
            this.filtering = true
            this.response = await this.$http.post('/search-user-hangout', {
                user_country: this.user_country,
                religion: this.religion,
                male: this.male,
                female: this.female,
                min_age: this.value[0],
                max_age: this.value[1],
            });

            this.filtering = false
            this.pageLoader = false


            if (!this.response.data.success) {
                swal.fire({
                    title: 'success',
                    width:350,
                    height:3,
                    text: this.response.data.message,
                    });
                    return;

                } else {

                    this.player = true
                    this.user_profile = this.response.data.profile_detail;
                    this.profile_pictures = this.response.data.user_pictures;
                    this.user_ages = this.response.data.user_ages;
                    this.image_path = this.response.data.image_path;
                   
             }
                                  
            }catch (err) {
                console.log(err);
        }
    },

    async loadMatchProfile(){
         try{

            this.filtering = true
            this.response = await this.$http.get('/get-match-users-hangout', )

            this.filtering = false

            if (!this.response.data.success) {
                swal.fire({
                    title: 'success',
                    width:350,
                    height:3,
                    text: this.response.data.message,
                    });
                    return;

                } else {

                    this.match_profile = this.response.data.profile_detail;
                    this.match_pictures = this.response.data.user_pictures;
                    this.image_path = this.response.data.image_path;
                    this.match_ages = this.response.data.user_ages;

             }
                                  
            }catch (err) {
            console.log(err);
        }
    },

    // eslint-disable-next-line
    async message(e) {
        this.pageLoader = true
        this.nextOption = true
        const response = await this.$http.post('/profile-hangout', {
            userid: e,
        });

        this.pageLoader = false
        this.client_profile = response.data.profile_detail;
        this.user_id = e
    },

    async sendMessage(){
        try{
            
            this.message_status = true
            this.response = await this.$http.post('/send-message', {
                userid: this.user_id,
                message: this.user_message
            });
    
            this.message_status = false
    
            if (!this.response.data.success) {
                swal.fire({
                    title: 'error',
                    width:450,
                    height:5,
                    text: this.response.data.message,
                    });
                    return;
    
                } else {
    
                    swal.fire({
                        icon: 'success',
                        title: 'message',
                        width:450,
                        height:5,
                        text: this.response.data.message,
                    });
                    this.nextOption = false
                    return;              
    
            }
                                
            }catch (err) {
                console.log(err);
        }
    },

    // select player
    async selectPlayer(e) {
        this.pageLoader = true
        this.select_player = true
        const response = await this.$http.post('/profile-hangout', {
            userid: e,
        });

        this.pageLoader = false
        this.client_profile = response.data.profile_detail;
        this.user_id = e
    },

    async partyModePlayer(e){
        this.user_id = e
    },

    gameList(e) {
        this.pageLoader = true
        this.select_player = false
        this.$router.push("player/"+e);
        this.pageLoader = false
    },

    // game mode
    async gameMode() {
        try{
            const response = await this.$http.post('/check-gamemode', {
                app_category: 1,
            });

            this.apikey = response.data.apikey
            this.regular = response.data.regular_fee
            this.silver = response.data.silver_fee
            this.gold = response.data.gold_fee

        if (!response.data.success) {
                this.choose_game = true;
            } else {
                
                this.choose_game = false;
                this.apikey = response.data.apikey
                this.regular = response.data.regular_fee
                this.silver = response.data.silver_fee
                this.gold = response.data.gold_fee
            }               
        }catch (err) {
            console.log(err);
        }
    },

    async choose_gametype(x, amount, y, z) {
    if( x == 1 ) {
        const response = await this.$http.post('/choose-game', {
            game_mode: x,
            userid: this.user_id,
            app_category: 1,
        });

        if (!response.data.success) {
                this.choose_game = false;
                return;
            } else {

                this.paid = response.data.paid
                if(this.paid == 0){
                    this.choose_game = false;
                    this.choose_credittype = true;
                    this.fees = amount;
                    this.package = y;
                    this.package_name = z;
                }
                else if(this.paid == 1) {
                    this.choose_game = false;
                    this.choose_credittype = false;
                    this.game_type_status = x;
                }
                return;              
            }
        }
        else if( x == 2 ) {
            this.choose_game = false;
            this.game_type_status = x;
        }
        else if( x == 3 ) {
            this.choose_credittype = false;
            this.game_type_status = x;
            this.$router.push('/home');
        }
    }
     
  }
}

</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans&family=Raleway&display=swap');

.boost-page {
  min-height: 100vh;
  padding: 1rem;
  background:
    radial-gradient(circle at top left, rgba(211, 62, 116, 0.12), transparent 28%),
    linear-gradient(180deg, #f7f8fc 0%, #ffffff 100%);
}

.hero-shell {
  margin: 0 auto 1rem;
  padding: 1.25rem 1.4rem;
  border: 1px solid rgba(211, 62, 116, 0.10);
  border-radius: 24px;
  background: linear-gradient(135deg, rgba(211, 62, 116, 0.10), rgba(10, 7, 15, 0.03));
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.08);
}

.boost-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.hero-copy {
  max-width: 680px;
}

.eyebrow,
.plans-kicker {
  margin: 0;
  color: #D33E74;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.hero-title {
  margin: 0;
  color: #111827;
  font-family: 'DM Sans';
  font-size: 1.8rem;
  font-weight: 800;
  line-height: 1.1;
}

.hero-desc,
.player-payinfo {
  margin: 0.45rem 0 0;
  color: #667085;
  font-size: 0.98rem;
}

.plans-mask {
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(8px);
}

.plans-panel {
  padding: 1.5rem;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 24px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfbfd 100%);
  box-shadow: 0 30px 70px rgba(15, 23, 42, 0.18);
}

.plans-title {
  margin-bottom: 1rem;
}

.player-title {
  color: #111827;
  font-family: 'DM Sans';
  font-size: 1.7rem;
  font-weight: 800;
}

.section-heading {
  margin: 1.25rem 0 0.9rem;
  color: #111827;
  font-family: 'DM Sans';
  font-size: 1rem;
  font-weight: 800;
}

.plans-group {
  margin-top: 0.5rem;
}

.plan-card {
  position: relative;
  height: 100%;
  padding: 1rem;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
}

.plan-card--interactive {
  cursor: pointer;
  transition: 0.2s ease;
}

.plan-card--interactive:hover {
  transform: translateY(-3px);
  border-color: rgba(211, 62, 116, 0.22);
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.10);
}

.plan-card--vip {
  background: linear-gradient(135deg, rgba(211, 62, 116, 0.08), rgba(255, 255, 255, 1));
}

.plan-card h4 {
  margin: 0.4rem 0 0.25rem;
  color: #111827;
  font-family: 'DM Sans';
  font-size: 1.1rem;
  font-weight: 800;
}

.plan-price {
  margin: 0;
  color: #D33E74;
  font-size: 1rem;
  font-weight: 800;
}

.plan-desc {
  margin-top: 0.6rem;
  color: #667085 !important;
  line-height: 1.6;
}

.plan-foot {
  margin-top: 0.9rem;
  color: #98a2b3;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.plan-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.35rem 0.65rem;
  border-radius: 999px;
  background: rgba(211, 62, 116, 0.10);
  color: #D33E74;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.plan-badge--accent {
  background: rgba(15, 23, 42, 0.06);
  color: #0f172a;
}

.plan-badge--vip {
  background: rgba(211, 62, 116, 0.12);
  color: #D33E74;
}

.player-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  min-width: 160px;
  padding: 0.75rem 1.25rem;
  border: 0;
  border-radius: 999px;
  background: linear-gradient(135deg, #0f172a, #1e293b);
  color: #fff;
  font-family: 'Raleway';
  font-weight: 700;
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.16);
}

.player-button:hover {
  transform: translateY(-1px);
}

.payment-mask {
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(8px);
}

.payment-wrapper {
  margin-top: 4vh;
}

.payment-panel {
  padding: 1.5rem;
  border-radius: 24px;
  background: #fff;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18);
}

.payment-card {
  padding: 0.95rem 1rem;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 16px;
  background: #fff;
  transition: 0.2s ease;
}

.payment-card:hover {
  transform: translateY(-2px);
  border-color: rgba(211, 62, 116, 0.20);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
}

.amount {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.9rem 1rem;
  margin: 1rem 0;
  border-radius: 16px;
  background: rgba(211, 62, 116, 0.06);
}

.fees {
  color: #475467;
  font-size: 0.92rem;
}

.price {
  color: #D33E74;
  font-size: 1.1rem;
  font-weight: 800;
}

.payment-types {
  display: grid;
  gap: 0.75rem;
}

.payhow {
  margin: 0.25rem 0 0.5rem;
  color: #111827;
  font-weight: 700;
}

.payment {
  cursor: pointer;
}

.modal-wrapper {
  margin-top: 4vh;
}

.plans-title .player-payinfo {
  max-width: 620px;
  margin: 0.4rem auto 0;
}

.loader{
    width:100%;
    height:300px;
    display:flex;
    align-items:center;
    justify-content:center;
    gap:20px;
    margin-top:-180px;
  }
  
  .dot{
    height:40px;
    width:40px;
    border-radius:50%;
  }
   .dot:nth-child(1){
    background-color:red;
    animation: jump 0.6s 0.5s ease-in infinite
  }
  .dot:nth-child(2){
    background-color:blue;
    animation: jump 0.6s 0.7s ease-in infinite
  }
  .dot:nth-child(3){
    background-color:orange;
    animation: jump 0.6s 0.9s ease-in infinite
  }
  
  @keyframes jump{
    0%{
      transform: translate3D(0,0,0);
      opacity: 0;
    }
      50%{
      transform: translate3D(0,-15px,0);
        opacity: 0.5;
    }
      100%{
      transform: translate3D(0,0,0);
        opacity: 1;
    }
  }

  .dropdown-menu {
    margin-top:10px;
    background: rgba(30, 30, 30, 0.8);
    border-radius: 4px;
    color:#ccc; 
    font-size: 12px;
}
.dropdown-menu > a {
    background: #312F33;
    color:#D33E74; 
}col
.dropdown-menu:hover {
    //background: #ccc;
    color:#D33E74; 
}
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .4s ease;
    & > div {
        //width: 100%;
        height: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        //padding: 2em;
        border: 1px solid #2F2F2F;
        //backdrop-filter: blur(13px);
        background: #19181B;
        border-radius: 20px;
        box-sizing: border-box;
      }
      .profile-view2{
        box-sizing: border-box;
        border-radius: 20px;
        //position:relative;
        width: 100%;
        height: 100%;
       // background: #111112;

        .profile-photo2{
            width: 100%;
            height: auto;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
        }
    }
    .profile-info2 {
    padding: 1rem 2rem 2rem 1rem;

        h3{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 800;
            font-size: 20px;
            line-height: 24px;
            text-align: left;
            color: #FFFFFF;
            margin-left: 20px;
        }
        p {
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 10px;
            text-align: left;
            color: #767475;
            margin-left: 20px;
        }
    }
    .profile-bio2{
        
        P {
            width: auto;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 154.2%;
            color: #767475;;
            text-align: left;
            margin:20px;
        }

    }
    .profile-interest2{
        
        h3 {
            width: auto;
            height: 26px;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 26px;
            text-align: left;
            color: #FFFFFF;
            margin:20px;
        }
        .interests2{
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 2px 8px;
            width: auto;
            height: 29px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 50px;
            color: #767475;
            font-size: 10px;
            margin: 4px;

        }
        .interests-info2 {
            display: flex;
            flex-direction: row;
            //padding: 0rem 3rem 5rem 1rem;
        }
    }
    .profile-relationship-goal2{
        margin-top: -150px !important;
        h3 {
            width: auto;
            height: 26px;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 26px;
            text-align: left;
            color: #FFFFFF;
            margin:20px;
        }
        .relationship-goal2 {
            display: flex;
            flex-direction: row;
            padding: 2px;
            width: 70%;
            height: auto;
            background: rgba(255, 214, 0, 0.1);
            border-radius: 61px;
            color: #FFD600;
            font-size: 10px;
            margin: 20px;
            text-align: left;
        }

    }
    .btn-unmatch-report2 {
        display: flex;
        flex-direction: row;
        align-items: center;
        .btn-unmatch2 {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #D33E74;
            margin: 20px;
            cursor: pointer;
        }
        .btn-unmatch3 {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #b1acae;
            margin: 20px;
            cursor: pointer;
        }
        .btn-report2 {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #2D2D2D;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #767475;
            margin-right: 10px;
            cursor: pointer;
        }
    }
  }
.modal-maskx {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .4s ease;
    & > div {
        width: 80%;
        height: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        //padding: 2em;
        border: 0.5px solid #D33E74;
        background: #19181B;
        border-radius: 20px;
        box-sizing: border-box;
    }
.plans-title{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.player-title{
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 24px;
    text-align: center;
    color: #FFFFFF;
}
.player-noimg {
    border-radius: 100%;
}
.playerimg{
    width: 40%;
    height: 40%;
    margin-top: 5px;
    border-radius: 100%;
    border: solid 2px #D33E74;
    margin-bottom:10px;
}
.player-name{
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 31px;
    text-align: center;
    color: #FFFFFF;

}
.player-payinfo{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 100%;
    background: rgba(217, 217, 217, 0.1);
    border-radius: 5px;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    color: #D9D9D9;

}
.player-button{
    align-content: center;
    padding: 10px;
    width: 280px;
    height: 40px;
    background: #D33E74;
    border-radius: 82px;
    font-family: 'Source Sans 3';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 10px;
    color: #FFFFFF;
    //margin-bottom: 20px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    }  
    .button-close{
        align-content: center;
        padding: 10px;
        width: auto;
        height: 40px;
        background: #19181B;
        border-radius: 82px;
        font-family: 'Source Sans 3';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 10px;
        color: #FFFFFF;
        //margin-bottom: 30px;
        display: block;
        margin-left: auto;
        margin-right: auto;
        cursor:pointer;
        }  
    
    .select-profile{
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.08) 68.1%, rgba(0, 0, 0, 0.5) 78.43%), #2F2F2F;
        border: 3px solid #D33E74;
        border-radius: 97px;
        width: 148px;
        height: 148px;
        display: block;
        margin-left: auto;
        margin-right: auto;
        margin-top: 15px;
        margin-bottom: 25px;
    }
}

.modal-masky {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 650px;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .4s ease;

    & > div {
        width: 80%;
        height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border: 0.5px solid #D33E74;
        background: #19181B;
        border-radius: 20px;
        box-sizing: border-box;
        overflow-y: scroll;
    }
.player-title{
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 24px;
    line-height: 42px;
    text-align: center;
    color: #FFFFFF;
}
.game-mode{
    display: flex; 
    flex-direction: row; 
    justify-content: space-between;
}
.title-color{
    font-size: 12px;
    color: #fff;
}
.live-mode {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    //padding: 0.2rem;
    width: 100%;
    height: auto;
    margin:0.2px;
    border: 1px solid #D33E74;
    border-radius: 4px;
    cursor: pointer;

    h4{
        font-family: 'DM Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        text-align: center;
        color: #D33E74;
    }
    p{
        font-family: 'DM Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 10px;
        text-align: center;
        color: #19181B;
    }
    
}
.live-mode:hover {
    border: 1px solid #D33E74 !important;

    P{
       color: #19181B;
   }
   h3{
       color: #19181B;
   }
}
.party-mode {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 220px;
    height: 180px;
    background: #19181B;
    border: 1px solid #D33E74;
    border-radius: 27px;
    cursor: pointer;

    h3{
        font-family: 'DM Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 20px;
        line-height: 42px;
        text-align: center;
        color: #FFFFFF;
    }
    p{
        font-family: 'DM Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 10px;
        line-height: 12px;
        text-align: center;
        color: #FFFFFF;
        margin-top: -10px;
    }
}
.player-name{
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 31px;
    text-align: center;
    color: #FFFFFF;

}
.player-payinfo{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    padding: 4px;
    width: 110%;
    height: 35px;
    background: rgba(211, 62, 116, 0.1);
    border-radius: 5px;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    text-align: center;
    color: #D33E74;
    margin-top: 20px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom:20px


}
.player-button{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 5px;
    height: auto;
    width: 180px;
    background: #111112;
    border-radius: 5px;
    font-family: 'Source Sans 3';
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 28px;
    color: #FFFFFF;
    margin-top: 10px;
    margin-bottom: 30px;
    display: block;
    margin-left: auto;
    margin-right: auto;
}   
}

.modal-maskp {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .4s ease;
        
        & > div {
            width: 80%;
            height: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            //padding: 2em;
            border: 0.5px solid #D33E74;
            background: #19181B;
            border-radius: 20px;
            box-sizing: border-box;
        }
    .player-title{
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 24px;
        line-height: 42px;
        text-align: center;
        color: #FFFFFF;
    }
    .amount {
        display: flex;
        flex-direction: row;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 19px;
        color: #FFFFFF;
        justify-content: space-between;
        .fees {
            
        }
        .price {
           
            font-family: 'Nunito';
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 27px;
            color: #D33E74;
        }
    }
    .payment-option{
        display: flex; 
        flex-direction: row; 
    }
    .payment-types {
        width: 388px;
        height: 254px;
        background: #272528;
        border-radius: 8px;
        cursor: pointer;
        margin-bottom:20px;
        .payhow{
            font-family: 'Nunito';
            font-style: normal;
            font-weight: 700;
            font-size: 12px;
            line-height: 10px;
            letter-spacing: -0.02em;
            color: #FFFFFF;
            text-align: center;
            margin-top: 10px;
        }
        .payment{
            margin:15px;
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 0px 14px;
            width: 314px;
            height: 46px;
            background: #19181B;
            border-radius: 4px;
            font-family: 'Nunito';
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            line-height: 22px;
            letter-spacing: -0.02em;
            color: #FFFFFF;
        }

        h3{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 42px;
            text-align: center;
            color: #0A070F;
        }
        
        
    }
    .player-payinfo{
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 11px;
        line-height: 14px;
        text-align: center;
        color: #FFFFFF;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }
    .player-button{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 5px;
        height: auto;
        //background: #111112;
        border-radius: 5px;
        font-family: 'Source Sans 3';
        font-style: normal;
        font-weight: 600;
        font-size: 10px;
        line-height: 28px;
        color: #FFFFFF;
        margin-top: 10px;
        margin-bottom: 30px;
        //display: block;
        margin-left: auto;
        margin-right: auto;
    }   
}

 .modal-window {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s;
    &:target {
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
    }
    & > div {
      width: 350px;
      height: 250px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      //padding: 2em;
      border: 1px solid #2F2F2F;
      backdrop-filter: blur(13px);
      background: #19181B;
      border-radius: 20px;
      box-sizing: border-box;
    }
    header {
      font-weight: bold;
    }
    h1 {
      font-size: 150%;
      margin: 0 0 15px;
    }
    h2 {
        margin-top: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 23px;
        text-align: center;
        color: #FFFFFF;
    }
    label {
        text-align: left;
        color: #fff;
        font-size: 12px;
        margin-left:15px;
        margin-bottom: -6px;
    }
    span {
        margin-bottom: 20px;
    }

  }
  .login-modal-box {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    margin-top: 10px;
    margin-left: 10px;
    background: #19181B;
    border: 0.5px solid #767475;
    border-radius: 50px;
    //width:500%;
  }
  .modal-close {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
  }
  .btn-login {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    gap: 10px;
    background: #D33E74;
    border-radius: 82px;
    margin-top: 8px;
    color: #fff;
    margin-left: 10px;
    
  }
  .modal-close-mobile {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
    display: none;
  }
  .main-page {
        padding: 10px 10px 60px 20px;
        width: 100%;
        height: auto;
        margin-left: -60px;
        background: transparent;
    }
    .tab {
    display: flex;
    flex-direction: row;
    text-align: center;
    width: 100%;

    .find-match {
        margin-top: -10px;
        width: 80px;
        height: 70px;
        background: #1E1D20;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        border-bottom: 1px solid #D33E74;

        p {
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 20px;
            line-height: 28px;
            text-align: center;
            color: #D33E74;
        }
    }
    .your-matches {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        text-align: center;
        color: #767475;
    }

    }
    .find-match:hover {
        margin-top: -10px;
        width: 80px;
        height: 70px;
        background: #1E1D20;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        border-bottom: 1px solid #D33E74;
        cursor: pointer;
    }
    .your-matches:hover {
        margin-top: -10px;
        border-bottom: 1px solid #D33E74;
        background: #1E1D20;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        cursor: pointer;

        p {
            color: #D33E74;
        }
    }
    .navigation{
        padding: 20px 50px 50px 40px;
        margin-top: -10px;
        display: flex;
        flex-direction: row;
    // align-items: center;
        //justify-content: center;

        .elipse{
            float: right;
            margin-left: 90%;
        }
    }
    .photo-row {
        position: relative;
        width: 120%;
       // margin-left: 40px;
        padding: 0rem 0rem 1rem 2rem;  
      
        .margin{
            margin-top: 0px;
        }

        .photo-footer{
            position: absolute;
            padding: 0rem 1rem;
            left: 0px;
            bottom: 15px;
            width: 100%;
            background: linear-gradient(180deg, #2E0B18 0%, rgba(0, 0, 0, 0.05) 32.53%), #2F2F2F;
            //border-bottom-left-radius: 20px;
            //border-bottom-right-radius: 20px;
            
            h3{
                margin-top: 8px;
                font-family: 'Raleway';
                font-style: normal;
                font-weight: 800;
                font-size: 14px;
                //line-height: 42px;
                text-align: left;
                color: #FFFFFF;
            }
            .footer-relationship{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 10px;
                line-height: 10px;
                text-align: left;
                color: #767475;

                span {
                    color: #FFF;
                }
            }
            .footer-location{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 10px;
                margin-top:-20px;
                text-align: left;
                color: #767475;
                margin-top: 6px;

                span {
                    color: #FFF;
                }
            }

        }
        .photo-footer1 {

            display: none;
            position: absolute;
            left: 14px;
            bottom: 0px;
            background: #D33E74;
            width: 89%;
            height: 60px;
            border-bottom-left-radius: 20px;
            border-bottom-right-radius: 20px;

            .comment {
                color: #FFFFFF;
                font-size: 50px;
                text-align: left;
                margin-top: 10px;
                margin-left: 8%;
                cursor: pointer;
            }
            .user {
                color: #FFFFFF;
                font-size:50px;
                text-align: right;
                margin-top: 10px;
                margin-left: 60%;
                padding: 0rem 0rem 0rem 0rem;
                cursor: pointer;
            }
        }
        
    }
    .photo-rowx {
        position: relative;
        width: 100%;
       // margin-left: 40px;
        padding: 0rem 0rem 1rem 2rem;  

        .marginx{
            margin-top: -40px;
        }
        .photo-footerx{
            position: absolute;
            padding: 0rem 1rem;
            left: 14px;
            height: 40px;
            bottom: 0px;
            background: #1E1D20;
            width: 86%;
            border-bottom-left-radius: 20px;
            border-bottom-right-radius: 20px;

            h3{
                margin-top: 4px;
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 10px;
                line-height: 1px;
                text-align: center;
                color: #FFFFFF;
            }
            p{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 10px;
                //line-height: px;
                text-align: center;
                color: #FFFFFF;
                margin-top: -14px;
            }
        }
        .photo-footer1 {

            display: none;
            position: absolute;
            left: 14px;
            bottom: 0px;
            background: #D33E74;
            width: 89%;
            height: 60px;
            border-bottom-left-radius: 20px;
            border-bottom-right-radius: 20px;

            .comment {
                color: #FFFFFF;
                font-size: 50px;
                text-align: left;
                margin-top: 10px;
                margin-left: 8%;
                cursor: pointer;
            }
            .user {
                color: #FFFFFF;
                font-size:50px;
                text-align: right;
                margin-top: 10px;
                margin-left: 60%;
                padding: 0rem 0rem 0rem 0rem;
                cursor: pointer;
            }
        }
        
    }
    .photo {
        //position: absolute;
        width: 100%;
        height: 100%;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
        border-radius: 20px;
        margin: 0px;
    }
    .profile-view{
        box-sizing: border-box;
        margin-top:30px;
        padding: 0rem 0rem 0rem 0rem;
        width: 120%;
        height: auto;
        background: #111112;

        .profile-photo {
            width: 100%;
            height: 200px;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
        }
    }
    .profile-info {
        padding: 1rem 2rem 2rem 1rem;

        h3{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 800;
            font-size: 20px;
            line-height: 24px;
            text-align: left;
            color: #FFFFFF;
            margin-left: 20px;
        }
        p {
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 10px;
            text-align: left;
            color: #767475;
            margin-left: 20px;
        }
    }
    .profile-bio{
        
        P {
            width: auto;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 154.2%;
            color: #767475;;
            text-align: left;
            margin:20px;
        }

    }
    .profile-interest{
    
        h3 {
            width: auto;
            height: 26px;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 26px;
            text-align: left;
            color: #FFFFFF;
            margin:20px;
        }
        .interests{
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 2px 8px;
            width: auto;
            height: 29px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 50px;
            color: #767475;
            font-size: 10px;
            margin: 4px;

        }

        .interests-info {
            display: flex;
            flex-direction: row;
        }

    }
    .profile-relationship-goal{
        h3 {
            width: auto;
            height: 26px;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 26px;
            text-align: left;
            color: #FFFFFF;
            margin:20px;
        }
        .relationship-goal {
            display: flex;
            flex-direction: row;
            padding: 2px;
            width: 70%;
            height: auto;
            background: rgba(255, 214, 0, 0.1);
            border-radius: 61px;
            color: #FFD600;
            font-size: 10px;
            margin: 20px;
            text-align: left;
        }

    }
    .btn-unmatch-report {
        display: flex;
        flex-direction: row;
        align-items: center;
        .btn-unmatch {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #D33E74;
            margin: 20px;
            
        }
        .btn-unmatch3 {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #b1acae;
            margin: 20px;
            cursor: pointer;
        }
        .btn-report {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #2D2D2D;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #767475;
            margin-right: 10px;
        }
    }

    // SEARCH FIELDS MENU
    .search-menu {
        display: flex;
        flex-direction: row;
        padding: 1rem 0rem 2rem 1rem;
        margin-top: -10px;
        .location {
            display: flex;
            flex-direction: column;
            justify-content: center;
           // align-items: center;
            padding: 10px;
            width: 210px;
            height: 98px;
            background: #1E1D20;
            border-radius: 11px;
            margin: 4px;

            span {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 18px;
                text-align: left;
                color: #FFFFFF;
            }
            .input-location {
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 10px 17px;
                width: 175px;
                height: 37px;
                background: #1E1D20;
                border: 0.5px solid #767475;
                border-radius: 50px;
                font-family: 'Raleway';
                font-style: normal;
                font-weight: 500;
                font-size: 12px;
                line-height: 14px;
                /* identical to box height */
                text-align: center;
                color: #767475;
            }
        }
        .location-range {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 0px;
            width: 380px;
            height: 98px;
            background: #1E1D20;
            border-radius: 11px;
            margin: 4px;
            .range {
                display: flex;
                flex-direction: row;
                align-content: space-evenly;
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 18px;
                color: #FFFFFF;
                padding: 2rem 1rem 1rem 0rem;
                .men-women {
                        padding: 0rem 3rem 1rem 2rem;
                    p {
                        margin-left:-20px;
                    }
                    .form-check-input{
                        background: #FFFFFF;
                        height: 20px;
                        width: 20px;
                        margin-top: -0px;
                    }
                    .form-check-input:checked{
                        background: #D33E74;
                        height: 22.5px;
                        width: 22.5px;
                    }
                    
                }
                .age-range {
                    width:100px;
                p {
                    margin-left: 20px;
                }
                .slider-bg{
                    background: #252426;
                    border-radius: 22px;
                }
               }
            }
        }
        .btn-filter-cancel {
            display: grid;
            flex-direction: column;
            margin: 2px;

            .btn-filter{
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 10px;
                width: 130px;
                height: 35px;
                background: #D33E74;
                border-radius: 82px;
                font-family: 'Source Sans 3';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 23px;
                color: #FFFFFF;
            }
            .btn-cancel{
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 10px;
                width: 130px;
                height: 35px;
                background: #2F2F2F;
                border-radius: 82px;
                border: 1px solid #D33E74;
                font-family: 'Source Sans 3';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 23px;
                color: #D33E74;
            }

        }
    }

    // SELECT PLAYER
    .player {
        h3{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 38px;
            text-align: left;
            color: #D33E74;
        }
    }

    .head-title {
        h2{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 900;
            font-size: 24px;
            line-height: 38px;
            text-align: left;
            color: #D33E74;
        }
    }

    // VIEW PROFILE FEATURE
    .profile-image-vp {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        padding: 0rem 2rem 3rem 0rem;
        margin-left: 10px;
        margin-top:-20px;
    
        .img-profile-vp {
            width: 60%;
            height: 60%;
            margin:2px;
            border-radius: 100px;
            //background: #D9D9D9;
        }
        .img-profilep-vp {
            width: 50%;
            height: 40%;
            margin-left:20px;
            margin: 10px;
            //padding: 0rem 0rem 0rem 0rem;
            border-radius: 100%;
            //background: #D9D9D9;
        }
        .profile-info-vp {
            margin-left: -40px;            
            h3 {
                font-family: 'Raleway';
                font-style: normal;
                font-weight: bold;
                font-size: 16px;
                line-height: 20px;
                text-align: left;
                color: #FFFFFF;
            }
            p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 13px;
                line-height: 20px;
                text-align: left;
                color: #FFFFFF;
            }        
        }
     }
    .profile-edit-button-vp{
    
       margin-left: -20px;
       padding: 3rem 2rem 3rem 0rem;
    
        .btn-edit {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px 18px;
            width: 120px;
            height: 40px;
            background: #D33E74;
            border: 0.5px solid #D33E74;
            border-radius: 50px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 12px;
            line-height: 21px;
            text-align: center;
            color: #FFFFFF;
        }
    }
    .photo-vp {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 16px;
        line-height: 28px;
        text-align: left;
        color: #FFFFFF;
        margin-left: 10px;
        margin-top: 2px;
    
    }
    .profile-image1-vp {
        display: flex;
        width: 100%;
        padding: 0rem 2rem 3rem 0rem;
        margin-left: 10px;
        margin-top: -12px;
        .add-picture1-vp {
            display: flex;
            .userpix-vp{
                width:195px;
                height:95%;
                border-radius: 15px;
                margin: 10px;
            }
        }
        .add-picture {
            margin-top: 10px;
           // background: url("../../assets/photo_add.png");
            background-size: cover;
            width: 65%;
            height: 222px;
            border-radius: 15px;
            padding-bottom: 0rem;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            cursor: pointer;
        }
        .img-profile1-vp {
            width: 105%;
            height: 105%;
            //padding: 0rem 1rem 0rem 2rem;
        }
        .profile-info-vp {            
            h3 {
                font-family: 'Raleway';
                font-style: normal;
                font-weight: bold;
                font-size: 25px;
                line-height: 20px;
                text-align: left;
                color: #FFFFFF;
            }
            p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 13px;
                line-height: 20px;
                text-align: left;
                color: #FFFFFF;
            } 
        }
     }
     .send-message{
        img{
            margin: 4px;
        }
        .imgpic {
            border: 10px solid rgba(211, 62, 116, 0.3);
            border-radius: 135px;
            display: block;
            margin-left: auto;
            margin-right: auto;
           // height: 100%;
           // margin-bottom: 14px;
        }
        .img-profile{
            border: 10px solid rgba(211, 62, 116, 0.3);
            border-radius: 135px;
            display: block;
            margin-left: auto;
            margin-right: auto;
        }
        .imgsms {
            width: 50%;
            display: block;
            margin-left: auto;
            margin-right: auto;
        }
        p{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 31px;
            text-align: center;
            color: #D9D9D9;

        }

        .chat-input {
            width: 100%;
            height: 40px;
            background: #1C1C1D;
            border-radius: 61px;
            margin-bottom: 20px;
            font-family: 'Mulish';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 23px;
            text-align: left;
            color: #2F2F2F;
            padding-left: 10px;
    
        }
        .p-viewer {
            float: right;
            margin-top: -52px;
            //margin-right: 18px;
            margin-left: 72%;
            position: relative;
            z-index: 1;
            cursor:pointer;
            .btn-info {
                margin-top: -4px;
                border-radius: 25px;
                background: #242325;
                font-size: 10px;
            }
        }
        .btn-primary{
            border-radius: 25px;
            background: #242325;
            font-size: 10px;
            color: #b1acae;
            border: none;
            width: 100%;
            margin-bottom: 10px;
            
        }
     }
    
    @media screen and (max-width: 700px) {
        .modal-mask {
            position: fixed;
            z-index: 9998;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .5);
            display: table;
            transition: opacity .4s ease;
             & > div {
                 width: 65%;
                 height: auto;
                 position: absolute;
                 top: 50%;
                 left: 50%;
                 transform: translate(-50%, -50%);
                 padding: 10px 0px 0px 0px;
                 border: 1px solid #2F2F2F;
                 //backdrop-filter: blur(13px);
                 background: #19181B;
                 border-radius: 20px;
                 box-sizing: border-box;
               }
         
               .profile-view2{
                 box-sizing: border-box;
                 border-radius: 20px;
                 position:relative;
                 left: 20px;
                 width: 55%;
                 height: 100%;
                // background: #111112;
         
                 .profile-photo2{
                     width: 100%;
                     height: auto;
                     background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
                 }
             }
             .profile-info2 {
             padding: 1rem 2rem 2rem 1rem;
         
                 h3{
                     font-family: 'Raleway';
                     font-style: normal;
                     font-weight: 800;
                     font-size: 20px;
                     line-height: 24px;
                     text-align: left;
                     color: #FFFFFF;
                     margin-left: 20px;
                 }
                 p {
                     font-family: 'DM Sans';
                     font-style: normal;
                     font-weight: 400;
                     font-size: 13px;
                     line-height: 10px;
                     text-align: left;
                     color: #767475;
                     margin-left: 20px;
                 }
             }
             .profile-bio2{
                 
                 P {
                     width: auto;
                     font-family: 'DM Sans';
                     font-style: normal;
                     font-weight: 400;
                     font-size: 12px;
                     line-height: 154.2%;
                     color: #767475;;
                     text-align: left;
                     margin:20px;
                 }
         
             }
             .profile-interest2{
                 
                 h3 {
                     width: auto;
                     height: 26px;
                     font-family: 'DM Sans';
                     font-style: normal;
                     font-weight: 700;
                     font-size: 20px;
                     line-height: 26px;
                     text-align: left;
                     color: #FFFFFF;
                     margin:20px;
                 }
                 .interests2{
                     box-sizing: border-box;
                     display: flex;
                     flex-direction: row;
                     justify-content: center;
                     align-items: center;
                     padding: 2px 8px;
                     width: auto;
                     height: 29px;
                     background: #111112;
                     border: 1px solid #D33E74;
                     border-radius: 50px;
                     color: #767475;
                     font-size: 10px;
                     margin: 4px;
         
                 }
         
                 .interests-info2 {
                     display: flex;
                     flex-direction: row;
                     //padding: 0rem 3rem 5rem 1rem;
                 }
             }
             .profile-relationship-goal2{
                 margin-top: -150px !important;
                 h3 {
                     width: auto;
                     height: 26px;
                     font-family: 'DM Sans';
                     font-style: normal;
                     font-weight: 700;
                     font-size: 20px;
                     line-height: 26px;
                     text-align: left;
                     color: #FFFFFF;
                     margin:20px;
                 }
                 .relationship-goal2 {
                     display: flex;
                     flex-direction: row;
                     padding: 2px;
                     width: 70%;
                     height: auto;
                     background: rgba(255, 214, 0, 0.1);
                     border-radius: 61px;
                     color: #FFD600;
                     font-size: 10px;
                     margin: 20px;
                     text-align: left;
                 }
         
             }
             .btn-unmatch-report2 {
                 display: flex;
                 flex-direction: row;
                 align-items: center;
                 .btn-unmatch2 {
                     box-sizing: border-box;
                     display: flex;
                     flex-direction: row;
                     justify-content: center;
                     align-items: center;
                     padding: 10px;
                     width: 55%;
                     height: 30px;
                     background: #111112;
                     border: 1px solid #D33E74;
                     border-radius: 82px;
                     font-family: 'Source Sans 3';
                     font-style: normal;
                     font-weight: 400;
                     font-size: 13px;
                     line-height: 28px;
                     color: #D33E74;
                     margin: 20px;
                 }
                 .btn-report2 {
                     display: flex;
                     flex-direction: row;
                     justify-content: center;
                     align-items: center;
                     padding: 10px;
                     width: 55%;
                     height: 30px;
                     background: #2D2D2D;
                     border-radius: 82px;
                     font-family: 'Source Sans 3';
                     font-style: normal;
                     font-weight: 400;
                     font-size: 13px;
                     line-height: 28px;
                     color: #767475;
                     margin-right: 10px;
                     cursor: pointer;
                 }
             }
           }
        
           .modal-maskx {
            position: fixed;
            z-index: 9998;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .5);
            display: table;
            transition: opacity .4s ease;
    
            & > div {
                width: 80%;
                height: auto;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                //padding: 2em;
                border: 0.5px solid #D33E74;
                background: #19181B;
                border-radius: 20px;
                box-sizing: border-box;
            }
        .player-title{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 800;
            font-size: 24px;
            line-height: 42px;
            text-align: center;
            color: #FFFFFF;
        }
        .player-noimg {
            border-radius: 100%;
            //margin-left: 50px;
            margin-bottom:10px;
        }
        .playerimg{
            width: 40%;
            height: 40%;
            margin-top: 5px;
            border-radius: 100%;
            border: solid 2px #D33E74;
            margin-bottom:10px;
        }
        .player-name{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 31px;
            text-align: center;
            color: #FFFFFF;
    
        }
        .player-payinfo{
            display: flex;
            flex-direction: row;
            justify-content: center;
            // align-items: center;
            padding: 10px;
            width: auto;
            height: 50px;
            background: rgba(217, 217, 217, 0.1);
            border-radius: 5px;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 500;
            font-size: 12px;
            line-height: 18px;
            color: #D9D9D9;
            margin-bottom: 30px;
    
        }
        .player-button{
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 100%;
            height: 40px;
            background: #D33E74;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 600;
            font-size: 18px;
            line-height: 28px;
            color: #FFFFFF;
            margin-bottom: 30px;
        }   
    }
    
    .modal-masky {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .4s ease;

        & > div {
            width: 90%;
            height: 430px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            //padding: 2em;
            border: 0.5px solid #D33E74;
            background: #19181B;
            border-radius: 20px;
            box-sizing: border-box;
            overflow-y: scroll;
        }
    .player-title{
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 24px;
        line-height: 42px;
        text-align: center;
        color: #FFFFFF;
    }
    .game-mode{
        display: flex; 
        flex-direction: column; 
    }
    .live-mode {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 2px;
        width: 100%;
        height: auto;
        margin:2px;
        border: 1px solid #D33E74;
        border-radius: 4px;
        cursor: pointer;
        overflow-y: scroll;

    h4{
        font-family: 'DM Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        text-align: center;
        color: #D33E74;
    }
    p{
        font-family: 'DM Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 13px;
        text-align: center;
        color: #19181B;
    }
    
}
.live-mode:hover {
    border: 1px solid #D33E74 !important;

    P{
       color: #19181B;
   }
   h3{
       color: #19181B;
   }
}
    .party-mode {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 10px;
        width: 220px;
        height: 160px;
        background: #19181B;
        border: 1px solid #D33E74;
        border-radius: 27px;
        cursor: pointer;

        h3{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 16px;
            line-height: 25px;
            text-align: center;
            color: #FFFFFF;
        }
        p{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 10px;
            line-height: 12px;
            text-align: center;
            color: #FFFFFF;
            margin-top: -10px;
        }
    }
    .player-name{
        font-family: 'DM Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 31px;
        text-align: center;
        color: #FFFFFF;

    }
    .player-payinfo{
        display: flex;
        flex-direction: row;
        justify-content: center;
        //align-items: center;
        align-content: center;
        padding: 4px;
        width: 100%;
        height: 35px;
        background: rgba(211, 62, 116, 0.1);
        border-radius: 5px;
        font-family: 'DM Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 10px;
        line-height: 14px;
        text-align: center;
        color: #D33E74;
        margin-top: 20px;
        display: block;
        margin-left: auto;
        margin-right: auto;


    }
    .player-button{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 5px;
        height: auto;
        width: 180px;
        background: #111112;
        border-radius: 5px;
        font-family: 'Source Sans 3';
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 28px;
        color: #D33E74;
        margin-top: 10px;
        margin-bottom: 30px;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }   
    }
    
        .modal-maskp {
                position: fixed;
                z-index: 9998;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, .5);
                display: table;
                transition: opacity .4s ease;
                
                & > div {
                    width: 80%;
                    height: auto;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    //padding: 2em;
                    border: 0.5px solid #D33E74;
                    background: #19181B;
                    border-radius: 20px;
                    box-sizing: border-box;
                }
            .player-title{
                font-family: 'Raleway';
                font-style: normal;
                font-weight: 800;
                font-size: 24px;
                line-height: 42px;
                text-align: center;
                color: #FFFFFF;
            }
            .amount {
                display: flex;
                flex-direction: row;
                font-family: 'Raleway';
                font-style: normal;
                font-weight: 500;
                font-size: 13px;
                line-height: 19px;
                color: #FFFFFF;
                justify-content: space-between;
                .fees {
                    
                    font-family: 'Nunito';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 12px;
                }
                .price {
                    
                    font-family: 'Nunito';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 12px;
                    line-height: 27px;
                    color: #D33E74;
                }
            }
            .payment-option{
                display: flex; 
                flex-direction: row; 
            }
            .payment-types {
                width: 100%;
                height: 254px;
                background: #272528;
                border-radius: 8px;
                cursor: pointer;
                .payhow{
                    font-family: 'Nunito';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 12px;
                    line-height: 10px;
                    letter-spacing: -0.02em;
                    color: #FFFFFF;
                    text-align: center;
                    margin-top: 10px;
                }
                .payment{
                    margin:15px;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    padding: 0px 14px;
                    width: 90%;
                    height: 46px;
                    background: #19181B;
                    border-radius: 4px;
                    font-family: 'Nunito';
                    font-style: normal;
                    font-weight: 600;
                    font-size: 11px;
                    line-height: 22px;
                    letter-spacing: -0.02em;
                    color: #FFFFFF;
                }
        
                h3{
                    font-family: 'DM Sans';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 20px;
                    line-height: 42px;
                    text-align: center;
                    color: #0A070F;
                }
                
                
            }
            .player-payinfo{
                font-family: 'Raleway';
                font-style: normal;
                font-weight: 500;
                font-size: 11px;
                line-height: 14px;
                text-align: center;
                color: #FFFFFF;
                display: block;
                margin-left: auto;
                margin-right: auto;
            }
            .player-button{
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 5px;
                height: auto;
                background: #111112;
                border-radius: 5px;
                font-family: 'Source Sans 3';
                font-style: normal;
                font-weight: 600;
                font-size: 10px;
                line-height: 28px;
                color: #FFFFFF;
                margin-top: 10px;
                margin-bottom: 30px;
                display: block;
                margin-left: auto;
                margin-right: auto;
            }   
        }
           .send-message{
            img{
                margin: 4px;
            }
            .imgpic {
                border: 10px solid rgba(211, 62, 116, 0.3);
                border-radius: 100%;
                display: block;
                margin-left: auto;
                margin-right: auto;
            }
            .img-profile{
                border: 10px solid rgba(211, 62, 116, 0.3);
                border-radius: 100%;
                display: block;
                margin-left: auto;
                margin-right: auto;
            }
            .imgsms {
                width: 50%;
                display: block;
                margin-left: auto;
                margin-right: auto;
            }
            p{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 12px;
                line-height: 31px;
                text-align: center;
                color: #D9D9D9;
    
            }
    
            .chat-input {
                width: 100%;
                height: 40px;
                background: #1C1C1D;
                border-radius: 61px;
                margin-bottom: 20px;
                font-family: 'Mulish';
                font-style: normal;
                font-weight: 500;
                font-size: 14px;
                line-height: 23px;
                text-align: left;
                color: #2F2F2F;
                padding-left: 10px;
        
            }
            .p-viewer {
                float: right;
                margin-top: -52px;
                //margin-right: 18px;
                margin-left: 72%;
                position: relative;
                z-index: 1;
                cursor:pointer;
                .btn-info {
                    margin-top: -4px;
                    border-radius: 25px;
                    background: #242325;
                    font-size: 10px;
                }
            }
            .btn-primary{
                border-radius: 25px;
                background: #242325;
                font-size: 10px;
                color: #b1acae;
                border: none;
                width: 100%;
                margin-bottom: 10px;
                
            }
         }
           .modal-xl {
              width: 90%;
              max-width:1200px;
           }
        .modal-close-mobile {
            color: #fff;
            line-height: 50px;
            font-size: 140%;
            position: absolute;
            right: 0;
            text-align: center;
            top: 2;
            width: 70px;
            text-decoration: none;
            &:hover {
              color: black;
            }
            display: block;
          }
        .tab {
            display: flex;
            flex-direction: row;
            text-align: center;
            width: 100%;
            padding: 1rem 0rem 0rem 6rem;
        
        
            .find-match {
            margin-top: -10px;
            width: 100%;
            height: 60px;
            background: #1E1D20;
            display: flex;
            flex-direction: columns;
            align-items: center;
            cursor: pointer;
        
            p {
                font-family: 'Raleway';
                font-style: normal;
                font-weight: 500;
                font-size: 14px;
                line-height: 28px;
                text-align: center;
                color: #D33E74;
            }
            }
            .your-matches {
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 28px;
            text-align: center;
            color: #767475;
            cursor: pointer;
            }
        
        }
        .navigation{
            padding: 1rem 2rem 3rem 4rem;
            margin-top: 30px;
            display: flex;
            flex-direction: row;
            
        // align-items: center;
            //justify-content: center;
        
            .elipse{
                float: right;
                margin-left: 90%;
            }
        }

        .photo-row{
           width: 100%;
           margin-left: 30px;

           .margin {
            margin: 10px;
           }
        .photo-footer{
            position: absolute;
            //padding: 0rem 4rem;
            left: 0px;
            bottom: 0px;
            width: 100%;

            h3{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 13px;
                line-height: 10px;
                text-align: left;
                color: #FFFFFF;
            }
            p{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 12px;
                line-height: 16px;
                text-align: left;
                color: #FFFFFF;
            }
        }
        }
        .photo-rowx {
        position: relative;
        width: 100%;
        margin-left: 25px;
        padding: 4rem 0rem 1rem 4rem;  

        .marginx{
            margin-top: -40px;
        }
        .photo-footerx{
            position: absolute;
            padding: 0rem 1rem;
            left: 14px;
            height: 40px;
            bottom: 0px;
            background: #1E1D20;
            width: 90%;
            border-bottom-left-radius: 20px;
            border-bottom-right-radius: 20px;

            h3{
                margin-top: 4px;
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 10px;
                line-height: 1px;
                text-align: center;
                color: #FFFFFF;
            }
            p{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 10px;
                //line-height: px;
                text-align: center;
                color: #FFFFFF;
                margin-top: -14px;
            }
        }
        .photo-footer1 {

            display: none;
            position: absolute;
            left: 14px;
            bottom: 0px;
            background: #D33E74;
            width: 89%;
            height: 60px;
            border-bottom-left-radius: 20px;
            border-bottom-right-radius: 20px;

            .comment {
                color: #FFFFFF;
                font-size: 50px;
                text-align: left;
                margin-top: 10px;
                margin-left: 8%;
                cursor: pointer;
            }
            .user {
                color: #FFFFFF;
                font-size:50px;
                text-align: right;
                margin-top: 10px;
                margin-left: 60%;
                padding: 0rem 0rem 0rem 0rem;
                cursor: pointer;
            }
        }
        
    }
        .photo {
            //position: absolute;
            width: 100%;
            height: 100%;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
            border-radius: 20px;
            //margin: 1px;
        }
        .profile-view{
            box-sizing: border-box;
            width: 100%;
            height: auto;
            background: #111112;
            margin-left: 75px;
        
            .profile-photo{
                width: 100%;
                height: 250px;
                background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
            }
        }
        .profile-info {
            padding: 1rem 2rem 2rem 1rem;
            
            h3{
                font-family: 'Raleway';
                font-style: normal;
                font-weight: 800;
                font-size: 20px;
                line-height: 24px;
                text-align: left;
                color: #FFFFFF;
                margin-left: 20px;
            }
            p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 13px;
                line-height: 10px;
                text-align: left;
                color: #767475;
                margin-left: 20px;
            }
        }
        .profile-bio{
            
            P {
                width: auto;
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 12px;
                line-height: 154.2%;
                color: #767475;;
                text-align: left;
                margin:20px;
            }
        
        }
        .profile-interest{
        
            h3 {
                width: auto;
                height: 26px;
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 20px;
                line-height: 26px;
                text-align: left;
                color: #FFFFFF;
                margin:20px;
            }
            .interests{
                box-sizing: border-box;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 10px 40px;
                width: 83px;
                height: 29px;
                background: #111112;
                border: 1px solid #D33E74;
                border-radius: 50px;
                color: #767475;
                font-size: 12px;
                margin: 4px;
        
            }
        
            .interests-info {
                display: flex;
                flex-direction: row;
                margin: 20px;
            }
        
        }
        .profile-relationship-goal{
            h3 {
                width: auto;
                height: 26px;
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 20px;
                line-height: 26px;
                text-align: left;
                color: #FFFFFF;
                margin:20px;
            }
            .relationship-goal {
                display: flex;
                flex-direction: row;
                padding: 10px;
                width: 70%;
                height: auto;
                background: rgba(255, 214, 0, 0.1);
                border-radius: 61px;
                color: #FFD600;
                font-size: 12px;
                margin: 20px;
                text-align: left;
            }
        
        }
        .btn-unmatch-report {
            display: flex;
            flex-direction: row;
            align-items: center;
        
        
            .btn-unmatch {
                box-sizing: border-box;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 10px;
                width: 60%;
                height: 35px;
                background: #111112;
                border: 1px solid #D33E74;
                border-radius: 82px;
                font-family: 'Source Sans 3';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 28px;
                color: #D33E74;
                margin: 20px;
        
                
            }
            .btn-report {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 10px;
                width: 60%;
                height: 35px;
                background: #2D2D2D;
                border-radius: 82px;
                font-family: 'Source Sans 3';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 28px;
                color: #767475;
                margin-right: 10px;
            }
        }
        .search-menu {
            display: flex;
            flex-direction: column;
            padding: 1rem 0rem 2rem 0rem;
            .location {
                display: flex;
                flex-direction: column;
                justify-content: center;
               // align-items: center;
                padding: 10px;
                width: 100%;
                height: 98px;
                background: #1E1D20;
                border-radius: 11px;
                margin: 4px;
    
                span {
                    font-family: 'DM Sans';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 18px;
                    text-align: left;
                    color: #FFFFFF;
                }
                .input-location {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    padding: 10px 17px;
                    width: 100%;
                    height: 36px;
                    background: #1E1D20;
                    border: 0.5px solid #767475;
                    border-radius: 50px;
                    font-family: 'Raleway';
                    font-style: normal;
                    font-weight: 500;
                    font-size: 12px;
                    line-height: 14px;
                    /* identical to box height */
                    text-align: center;
                    color: #767475;
                }
            }
            .location-range {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 0px;
                width: 100%;
                height: 98px;
                background: #1E1D20;
                border-radius: 11px;
                margin: 4px;
                .range {
                    display: flex;
                    flex-direction: row;
                    align-content: space-evenly;
                    font-family: 'DM Sans';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 18px;
                    color: #FFFFFF;
                    padding: 2rem 1rem 1rem 0rem;
                    .men-women {
                            padding: 0rem 3rem 1rem 2rem;
                        p {
                            margin-left:-20px;
                        }
                        .form-check-input{
                            background: #FFFFFF;
                            height: 20px;
                            width: 20px;
                            margin-top: -0px;
                        }
                        .form-check-input:checked{
                            background: #D33E74;
                            height: 22.5px;
                            width: 22.5px;
                        }
                        
                    }
                    .age-range {
                        width:100px;
                        //padding: 2rem 3rem 3rem 0rem;
                    p {
                        margin-left: 40px;
                    }
                    .slider-bg{
                        background: #252426;
                        border-radius: 22px;
                    }
                   }
                }
            }
            .btn-filter-cancel {
                display: flex;
                flex-direction: row;
                padding: 1rem 1rem 1rem 2rem;
                .btn-filter{
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    padding: 10px;
                    width: 130px;
                    height: 35px;
                    background: #D33E74;
                    border-radius: 82px;
                    font-family: 'Source Sans 3';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 23px;
                    color: #FFFFFF;
                }
                .btn-cancel{
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    padding: 10px;
                    width: 130px;
                    height: 35px;
                    background: #2F2F2F;
                    border-radius: 82px;
                    border: 1px solid #D33E74;
                    font-family: 'Source Sans 3';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 23px;
                    color: #D33E74;
                }
    
            }
        }
        .head-title {
            h2{
                font-family: 'Raleway';
                font-style: normal;
                font-weight: 900;
                font-size: 24px;
                line-height: 38px;
                text-align: left;
                color: #D33E74;
                margin-left: 40px;
            }
        }

         // VIEW PROFILE FEATURE
    .profile-image-vp {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        padding: 0rem 2rem 3rem 0rem;
        margin-left: 30%;
        margin-top:-20px;
    
        .img-profile-vp {
            width: 50%;
            height: 50%;
            margin:2px;
            border-radius: 100px;
        }
        .img-profilep-vp {
            width: 50%;
            height: 40%;
            margin-left:20px;
            margin: 10px;
            border-radius: 100%;
        }
        .profile-info-vp {           
            h3 {
                font-family: 'Raleway';
                font-style: normal;
                font-weight: bold;
                font-size: 15px;
                line-height: 15px;
                text-align: left;
                color: #FFFFFF;
            }
            p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 13px;
                line-height: 20px;
                text-align: left;
                color: #FFFFFF;
            }        
        }
     }
    .profile-edit-button-vp{
    
       margin-left: 50%;
       margin-top: -20%;
       //padding: 3rem 2rem 3rem 0rem;
    
        .btn-edit {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px 18px;
            width: 120px;
            height: 40px;
            background: #D33E74;
            border: 0.5px solid #D33E74;
            border-radius: 50px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 12px;
            line-height: 21px;
            text-align: center;
            color: #FFFFFF;
        }
    }
    .photo-vp {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 16px;
        line-height: 28px;
        text-align: left;
        color: #FFFFFF;
        margin-left: 100px;
        margin-top: 2px;
    
    }
    .profile-image1-vp {
        display: flex;
        width: 100%;
        padding: 0rem 2rem 3rem 0rem;
        margin-left: 100px;
        //margin-top: -12px;
        .add-picture1-vp {
            display: flex;
            .userpix-vp{
                width:195px;
                height:95%;
                border-radius: 15px;
                margin: 10px;
            }
        }
        .add-picture {
            margin-top: 10px;
            //background: url("../../assets/photo_add.png");
            background-size: cover;
            width: 65%;
            height: 222px;
            border-radius: 15px;
            padding-bottom: 0rem;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            cursor: pointer;
        }
        .img-profile1-vp {
            width: 105%;
            height: 105%;
            //padding: 0rem 1rem 0rem 2rem;
        }
        .profile-info-vp {            
            h3 {
                font-family: 'Raleway';
                font-style: normal;
                font-weight: bold;
                font-size: 25px;
                line-height: 20px;
                text-align: left;
                color: #FFFFFF;
            }
            p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 13px;
                line-height: 20px;
                text-align: left;
                color: #FFFFFF;
            } 
        }
     }

     .modal-maskx {
        // position: fixed;
         z-index: 9998;
         top: 0;
         left: 0;
         //width: 100%;
         height: 100%;
         //background: rgba(0, 0, 0, .5) !important;
         display: table;
         transition: opacity .3s ease;
         & > div {
             width: 80%;
             height: auto;
             position: absolute;
             top: 50%;
             left: 50%;
             transform: translate(-50%, -50%);
             //padding: 2em;
             border: 0.5px solid #D33E74;
             background: #19181B;
             border-radius: 20px;
             box-sizing: border-box;
           }
        .player-title{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 800;
            font-size: 24px;
            line-height: 42px;
            text-align: center;
            color: #FFFFFF;
        }
        .player-noimg {
            border-radius: 100%;
            //margin-left: 50px;
            margin-bottom:10px;
        }
        .playerimg{
            width: 40%;
            height: 40%;
            margin-top: 5px;
            border-radius: 100%;
            border: solid 2px #D33E74;
            margin-bottom:10px;
        }
        .player-name{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 31px;
            text-align: center;
            color: #FFFFFF;
    
        }
        .player-payinfo{
            display: flex;
            flex-direction: row;
            justify-content: center;
           // align-items: center;
            padding: 10px;
            width: auto;
            height: 50px;
            background: rgba(217, 217, 217, 0.1);
            border-radius: 5px;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 500;
            font-size: 12px;
            line-height: 18px;
            color: #D9D9D9;
            margin-bottom: 30px;
    
        }
        .player-button{
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 100%;
            height: 40px;
            background: #D33E74;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 600;
            font-size: 18px;
            line-height: 28px;
            color: #FFFFFF;
            margin-bottom: 30px;
        }   
       }

     
     }
 
     @media screen and (max-width: 768px) {
        .boost-page {
            padding: 14px 12px 42px;
        }

        .hero-shell {
            padding: 22px 18px;
            margin-bottom: 18px;
            border-radius: 24px;
        }

        .boost-nav {
            flex-direction: column;
            align-items: flex-start;
            gap: 10px;

            .main-heading {
                font-size: 16px;
                line-height: 1.3;
            }
        }

        .hero-title {
            font-size: 28px;
            line-height: 1.15;
        }

        .hero-desc {
            font-size: 14px;
            line-height: 1.6;
        }

        .plans-mask {
            padding: 0;
            background: transparent;
        }

        .plans-panel {
            border-radius: 24px;
            padding: 18px 14px;
        }

        .plans-group {
            grid-template-columns: 1fr;
            gap: 14px;
        }

        .plan-card {
            padding: 18px 16px;
            border-radius: 20px;
        }

        .plan-price {
            font-size: 28px;
            line-height: 1.1;
        }

        .section-heading {
            flex-direction: column;
            align-items: flex-start;
            gap: 6px;
            margin-bottom: 14px;
        }

        .payment-wrapper {
            padding: 0 6px;
        }

        .payment-panel {
            padding: 18px 16px;
            border-radius: 24px;
        }

        .payment-card {
            padding: 14px;
            border-radius: 18px;
        }

        .player-button {
            height: 46px;
            font-size: 16px;
        }

        .modal-wrapper {
            padding: 10px 8px 22px;
        }
    }
 
</style>
